import { useSyncExternalStore } from 'react'

import { featuresOf } from '../lib/features'
import { useAuthStore } from '../store/authStore'

const publicProfilesEnabled = () => featuresOf(useAuthStore.getState().user).publicProfilesEnabled
const repeatCount = () => featuresOf(useAuthStore.getState().user).repeatCount
const repeatMatchThreshold = () => featuresOf(useAuthStore.getState().user).repeatMatchThreshold
const autoPost = () => featuresOf(useAuthStore.getState().user).autoPost

/**
 * Whether names and avatars may open `/u/:userId` (V5-w-flags): AppSetting
 * `social.publicProfilesEnabled`, read from the signed-in profile's
 * `features`. Off (production until stage 3) the server answers 404 for
 * every other learner's profile, so the client does not link to it.
 *
 * Subscribed directly rather than through the store hook so the server
 * snapshot is the current state too (zustand's own server snapshot is the
 * initial, signed-out state) — the render tests depend on that. The
 * snapshot is a boolean, so it is stable between renders.
 */
export function usePublicProfilesEnabled() {
  return useSyncExternalStore(useAuthStore.subscribe, publicProfilesEnabled, publicProfilesEnabled)
}

/**
 * R13: how a practice repeats — `practice.repeatCount` (1 = the single take)
 * and `practice.repeatMatchThreshold` (0 = any speech counts). Two primitive
 * snapshots rather than one object, so each is stable between renders.
 */
export function useRepeatRule() {
  const count = useSyncExternalStore(useAuthStore.subscribe, repeatCount, repeatCount)
  const threshold = useSyncExternalStore(useAuthStore.subscribe, repeatMatchThreshold, repeatMatchThreshold)
  return { count, threshold }
}

/** R13: the server posts every scored take to the feed (`social.autoPost`) — no share or unshare control, consent before practice. */
export function useAutoPost() {
  return useSyncExternalStore(useAuthStore.subscribe, autoPost, autoPost)
}
